import React from "react";
import NavigateBot from "./NavigateBot/NavigateBot";
import NavbarReact from "./NavbarReact/NavbarReact";

function App() {
  return( 
    <div>
  <NavigateBot />
  </div>
  );
}

export default App;
